<template>
  <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <div
        v-if="readonly"
        style="
          text-align: center;
          font-weight: 800;
          width: 100%;
          background-color: wheat;
          color: red;
        "
      >
        READ ONLY
      </div>
      <h4>Team {{ team }}</h4>
      <!-- team select -->
      <!-- <v-select
        :items="['CAO', 'MET1', 'MET2', 'Other']"
        v-model="team"
        @change="team_select"
        label="Your Team"
      ></v-select> -->

      <v-text-field
        v-mask="'##/##/####'"
        maxlength="10"
        v-model="stat_data.stat_date"
        label="Date"
      ></v-text-field>
      <v-select
        v-model="stat_data.area"
        :items="area_items"
        :rules="[(v) => !!v || 'Item is required']"
        label="AREA"
        required
        background-color="#ECEFF1"
      ></v-select>
      <v-text-field
        maxlength="120"
        v-if="stat_data.area == 'Other'"
        placeholder="Enter Other Area Name"
        v-model="stat_data.other_area"
        label="Other Area"
        solo
      ></v-text-field>

      <h4>Standard</h4>
      <!-- <v-select
        v-model="stat_data.mission"
        :items="mission_types"
        label="MISSION"
        background-color="#ECEFF1"
        :rules="[(v) => !!v || 'Item is required']"
      >
        <template v-slot:item="slotProps">
          {{ slotProps.item }}
        </template>
      </v-select> -->

      <div>
        <!-- mobile drops -->
        <v-container class="pa-0 smonly" id="mobile_drops">
          <!-- deeds_hours -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="deeds_hours">Deeds Hours/Min</label>
            <select
              class="bcs_sel"
              v-model="stat_data.deeds_hours"
              id="deeds_hours"
            >
              <option
                v-for="(aint, index) in dhours15"
                :key="index"
                :value="aint"
              >
                {{ aint }}
              </option>
            </select>
          </div>
          <!-- group 1 -->
          <div>
            <!-- patrol_investigations -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="patrol_investigations"
                >Investigations Follow-up</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.patrol_investigations"
                id="patrol_investigations"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- subject_stops -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="subject_stops">Subject Stops</label>
              <select
                class="bcs_sel"
                v-model="stat_data.subject_stops"
                id="subject_stops"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- gtar -->
            <div class="d-flex justify-start">
              <label for="gtar" class="bcs_lbl">GTAR</label>
              <select class="bcs_sel" v-model="stat_data.gtar" id="gtar">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>
          <!-- group 2 -->
          <div>
            <!-- planned_operations -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl">Planned Operations</label>
              <select
                class="bcs_sel"
                v-model="stat_data.planned_operations"
                id="planned_operations"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- cfs_handled -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="cfs_handled">CFS Handled</label>
              <select
                class="bcs_sel"
                v-model="stat_data.cfs_handled"
                id="cfs_handled"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!--cfs_handled_reports-->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="cfs_handled_reports"
                >CFS Handled Reports</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.cfs_handled_reports"
                id="cfs_handled_reports"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- felony_arrests -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="felony_arrests">Felony Arrests</label>
              <select
                class="bcs_sel"
                v-model="stat_data.felony_arrests"
                id="felony_arrests"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- group 3 -->
          <div>
            <!-- gross_mido_arrests -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="gross_mido_arrests"
                >Gross Mido Arrests</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.gross_mido_arrests"
                id="gross_mido_arrests"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- misdo_arrests -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="misdo_arrests">Misdo Arrests</label>
              <select
                class="bcs_sel"
                v-model="stat_data.misdo_arrests"
                id="misdo_arrests"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- rmc_cites -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="rmc_cites">RMC Cites</label>
              <select
                class="bcs_sel"
                v-model="stat_data.rmc_cites"
                id="rmc_cites"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- traffic_stops -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="bus_contacts">Traffic Stops</label>
              <select
                class="bcs_sel"
                v-model="stat_data.bus_contacts"
                id="bus_contacts"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- group 4 -->
          <div>
            <!-- traffic_citations -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="Traffic Citations"
                >traffic_citations</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.traffic_citations"
                id="traffic_citations"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- warnings -->
            <div class="d-flex justify-start mt-4">
              <label class="bcs_lbl" for="warnings">Warnings </label>
              <select
                class="bcs_sel"
                v-model="stat_data.warnings"
                id="warnings"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- area_check -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="area_check">Area Check</label>
              <select
                class="bcs_sel"
                v-model="stat_data.area_check"
                id="area_check"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!--business_check-->
            <div class="d-flex justify-start mt-4">
              <label class="bcs_lbl" for="business_check"
                >Business Check
              </label>
              <select
                class="bcs_sel"
                v-model="stat_data.business_check"
                id="business_check"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- group 5 -->
          <div>
            <!-- bus_contacts-->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="bus_contacts">Bus. Contacts</label>
              <select
                class="bcs_sel"
                v-model="stat_data.bus_contacts"
                id="bus_contacts"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- citizen_contacts-->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="bus_contacts">Citizen Contacts</label>
              <select
                class="bcs_sel"
                v-model="stat_data.citizen_contacts"
                id="citizen_contacts"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- Controlled substances_seized -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="substances_seized"
                >Controlled Substances Seized (Grams)</label
              >
              <v-text-field
                class="controlled"
                single-line
                style="width: 80%"
                id="substances_seized"
                type="number"
                v-model="stat_data.substances_seized"
              ></v-text-field>
            </div>

            <!-- firearms_seized -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="firearms_seized"
                >Firearms Seized</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.firearms_seized"
                id="firearms_seized"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- group 6 -->
          <div>
            <!-- Vehicle Posted -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl">Vehicle Posted</label>
              <select
                class="bcs_sel"
                v-model="stat_data.vehicle_posted"
                id="d20arrest"
              >
                <option v-for="(aint, index) in d30" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!-- Vehicle Towed -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl">Vehicle Towed</label>
              <select
                class="bcs_sel"
                v-model="stat_data.vehicle_towed"
                id="vehicle_towed"
              >
                <option v-for="(aint, index) in d10" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <div></div>
            <div class="mt-4">
              <label class="bcs_lbl" for="notes">Narrative</label>
              <v-textarea
                id="notes"
                class="mt-2"
                counter
                solo
                name="notes"
                v-model="stat_data.notes"
              ></v-textarea>
            </div>
          </div>
          <!-- save/reset buttons -->
          <v-row class="" v-if="!readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="save_stat"
              >
                Submit
              </v-btn>
              <v-btn
                v-if="edit_on == true"
                color="cmpbk"
                class="mr-4 white--text"
                @click="cancel_edit"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="edit_on == false"
                color="cmpbk"
                class="mr-4 white--text"
                @click="reset"
              >
                Reset Form
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="" v-if="readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                id="quit_view"
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="quit_view"
              >
                Quit View
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <!-- deskstop -->
        <v-container class="pa-0 mdonly">
          <!-- row 1 -->
          <div class="mt-3 drop-row d-flex justify-center align-end">
            <!-- deeds_hours -->
            <div class="sel-int-col-25">
              <label for="deeds_hours">Deeds Hours/Min</label>
              <select v-model="stat_data.deeds_hours" id="deeds_hours">
                <option
                  v-for="(aint, index) in dhours15"
                  :key="index"
                  :value="aint"
                >
                  {{ aint }}
                </option>
              </select>
            </div>
            <!-- patrol_investigations -->
            <div class="sel-int-col-25">
              <label for="patrol_investigations" style="word-break: keep-all"
                >Investigations Followup</label
              >
              <select
                v-model="stat_data.patrol_investigations"
                id="patrol_investigations"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!-- subject_stops -->
            <div class="sel-int-col-25">
              <label for="subject_stops">Subject Stops</label>
              <select v-model="stat_data.subject_stops" id="subject_stops">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- gtar -->
            <div class="sel-int-col-25">
              <label for="gtar">GTAR</label>
              <select v-model="stat_data.gtar" id="gtar">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 2 -->
          <div class="drop-row d-flex justify-center align-end">
            <!-- misdo_arrests -->
            <div class="sel-int-col-25">
              <label for="planned_operations">Planned Operations </label>
              <select
                v-model="stat_data.planned_operations"
                id="planned_operations"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <div class="sel-int-col-25">
              <label for="cfs_handled">CFS Handled</label>
              <select v-model="stat_data.cfs_handled" id="cfs_handled">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- cfs_handled_reports -->
            <div class="sel-int-col-25">
              <label for="cfs_handled_reports"> CFS Handled Reports</label>
              <select
                v-model="stat_data.cfs_handled_reports"
                id="cfs_handled_reports"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!-- felony_arrests -->
            <div class="sel-int-col-25">
              <label for="felony_arrests">Felony Arrests </label>
              <select v-model="stat_data.felony_arrests" id="felony_arrests">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 3 -->
          <div class="drop-row d-flex justify-center align-end">
            <!-- gross_mido_arrests -->
            <div class="sel-int-col-25">
              <label for="gross_mido_arrests">Gross Misdo Arrests</label>
              <select
                v-model="stat_data.gross_mido_arrests"
                id="gross_mido_arrests"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- misdo_arrests -->
            <div class="sel-int-col-25">
              <label for="misdo_arrests">Misdo Arrests</label>
              <select v-model="stat_data.misdo_arrests" id="misdo_arrests">
                <option v-for="(aint, index) in d60" :key="index">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- rmc_cites -->
            <div class="sel-int-col-25">
              <label for="area_check">RMC Cites</label>
              <select v-model="stat_data.rmc_cites" id="rmc_cites">
                <option v-for="(aint, index) in d60" :key="index">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- traffic_stops -->
            <div class="sel-int-col-25">
              <label for="traffic_stops">Traffic Stops</label>
              <select v-model="stat_data.traffic_stops" id="traffic_stops">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 4 -->
          <div class="drop-row d-flex justify-center align-end">
            <!--  traffic_citations -->
            <div class="sel-int-col-25">
              <label for="traffic_citations">Traffic Citations</label>
              <select
                v-model="stat_data.traffic_citations"
                id="traffic_citations"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- warnings -->
            <div class="sel-int-col-25">
              <label for="warnings">Warnings</label>
              <select v-model="stat_data.warnings" id="warnings">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- area_check -->
            <div class="sel-int-col-25">
              <label for="area_check">Area Check</label>
              <select v-model="stat_data.area_check" id="area_check">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- business_check -->
            <div class="sel-int-col-25">
              <label for="business_check">business_check</label>
              <select v-model="stat_data.business_check" id="business_check">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 5 -->
          <div class="drop-row d-flex justify-center align-end">
            <!-- Business Contacts -->
            <div class="sel-int-col-25">
              <label for="bus_contacts">Business <br />Contacts</label>
              <select v-model="stat_data.bus_contacts" id="bus_contacts">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- citizen_contacts -->
            <div class="sel-int-col-25">
              <label for="citizen_contacts">Citizen Contacts&nbsp;</label>
              <select
                v-model="stat_data.citizen_contacts"
                id="citizen_contacts"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!-- substances_seized -->
            <div class="sel-int-col-25">
              <label for="substances_seized"
                >Controlled Substances Seized (Grams)</label
              >
              <v-text-field
                class="controlled"
                style="height: 45px; width: 80%"
                id="substances_seized"
                type="number"
                v-model="stat_data.substances_seized"
              ></v-text-field>
            </div>

            <!-- firearms_seized -->
            <div class="sel-int-col-25">
              <label for="citizen_contacts">Firearms Seized&nbsp;</label>
              <select v-model="stat_data.firearms_seized" id="firearms_seized">
                <option v-for="(aint, index) in 260" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 6 -->
          <div class="drop-row d-flex justify-center align-end mt-4">
            <div class="sel-int-col-25">
              <label for="vehicle_posted">Vehicle Posted </label>
              <select v-model="stat_data.vehicle_posted" id="vehicle_posted">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- vehicle_towed -->
            <div class="sel-int-col-25">
              <label>vehicle_towed</label>
              <select v-model="stat_data.vehicle_towed" id="vehicle_towed">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <div
            class="drop-row d-flex justify-center align-end mt-2"
            style="height: auto"
          >
            <div class="mt-4" style="width: 100%">
              <label class="bcs_lbl" for="d20ddeeds_outreach_accepted"
                >Narrative</label
              >
              <v-textarea
                class="mt-2"
                counter
                solo
                name="notes"
                v-model="stat_data.notes"
              ></v-textarea>
            </div>
          </div>

          <!-- save/reset buttons -->
          <v-row class="" v-if="!readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="save_stat"
              >
                Submit
              </v-btn>
              <v-btn
                v-if="edit_on == true"
                color="cmpbk"
                class="mr-4 white--text"
                @click="cancel_edit"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="edit_on == false"
                color="cmpbk"
                class="mr-4 white--text"
                @click="reset"
              >
                Reset Form
              </v-btn>
            </v-col>
          </v-row>
          <!-- save/reset buttons -->
          <v-row class="" v-if="readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                id="quit_view"
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="quit_view"
              >
                Quit View
              </v-btn>
            </v-col>
            <!-- <v-col cols="6">
          <v-btn color="cmpbk" class="mr-4 white--text" @click="reset">
            Reset Form
          </v-btn>
        </v-col> -->
          </v-row>
        </v-container>
      </div>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */
@media (min-width: 0px) {
  .thick {
    border: 1px solid rgb(3, 3, 82);
    margin-bottom: 3px;
  }
  .controlled:deep #substances_seized {
    text-align: right;
  }
  .smonly div.d-flex {
    margin-top: 10px;
  }
  .bcs_sel {
    width: 50%;
    // border: 1px solid black;
    background-color: whitesmoke;
    padding: 3px;
    margin-top: 3px;
  }
  .bcs_lbl {
    width: 50% !important;
    padding: 3px;
    margin-top: 6px;
  }
  .mdonly {
    display: none;
  }

  .drop-row {
    height: 95px;
  }
  .sel-int-col-25 {
    width: 25%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-33 {
    width: 33%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }
  .sel-int-col-50 {
    width: 50%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }
  .sel-int-col-100 select {
    width: 78%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
  // .sel-int-col-25 label {
  //   position: relative;
  //   top: 25px;
  // }
  .sel-int-col-25 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .sel-int-col-50 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .sel-int-col-33 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .sel-int-col-33 input {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .stop-select {
    width: 95% !important;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    margin-left: 0 !important;
  }

  select {
    -webkit-appearance: listbox !important;
    appearance: listbox !important;
  }
  .v-input--selection-controls.v-input {
    height: 40px;
  }
}
/* 768 media q */
@media (min-width: 768px) {
  .mdonly {
    display: block;
  }
  .smonly {
    display: none;
  }
  .sel-int-col-100 select {
    width: 100%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;

    // position: relative;
    // top: 10px;
  }
  .stop-select {
    width: 95% !important;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    margin-left: 0 !important;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}
/* 1025 media q */
@media (min-width: 1025px) {
}
/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "add_edit27",
  mixins: [bus_common],
  components: {},
  props: [
    "addedit_update_now",
    "incoming_edit",
    "source",
    "scrollpos",
    "edit_on",
    "lst_grants",
    "team",
    "readonly",
  ],
  //source will be 'srch' or 'rcnt'
  //scroll postion the name of the scroll postion
  data: () => ({
    show_addedit: true,
    address: "",
    loc: {},
    map_dialog_visible: false,
    stat_data: {
      rpd_stat_27_Id: 0,

      area: "",
      other_area: "",

      deeds_hours: "0.00",
      patrol_investigations: 0,
      subject_stops: 0,
      gtar: 0,

      planned_operations: 0,
      cfs_handled: 0,
      cfs_handled_reports: 0,
      felony_arrests: 0,

      gross_mido_arrests: 0,
      misdo_arrests: 0,
      rmc_cites: 0,
      traffic_stops: 0,

      traffic_citations: 0,
      warnings: 0,
      area_check: 0,
      business_check: 0,

      bus_contacts: 0,
      citizen_contacts: 0,
      substances_seized: 0,
      firearms_seized: 0,

      vehicle_posted: 0,
      vehicle_towed: 0,
      notes: "",
    },
    stat_data_dev: {
      rpd_stat_27_Id: 0,

      area: "Other",
      other_area: "fish",

      deeds_hours: "10.15",
      patrol_investigations: 1,
      subject_stops: 2,
      gtar: 3,

      planned_operations: 4,
      cfs_handled: 5,
      cfs_handled_reports: 6,
      felony_arrests: 7,

      gross_mido_arrests: 8,
      misdo_arrests: 9,
      rmc_cites: 10,
      traffic_stops: 11,

      traffic_citations: 12,
      warnings: 13,
      area_check: 14,
      business_check: 15,

      bus_contacts: 16,
      citizen_contacts: 17,
      substances_seized: 180,
      firearms_seized: 19,

      vehicle_posted: 20,
      vehicle_towed: 1,
      notes: "Happy Stats",
    },
    stat_data_new: {
      rpd_stat_27_Id: 0,

      area: "",
      other_area: "",

      deeds_hours: "0.00",
      patrol_investigations: 0,
      subject_stops: 0,
      gtar: 0,

      planned_operations: 0,
      cfs_handled: 0,
      cfs_handled_reports: 0,
      felony_arrests: 0,

      gross_mido_arrests: 0,
      misdo_arrests: 0,
      rmc_cites: 0,
      traffic_stops: 0,

      traffic_citations: 0,
      warnings: 0,
      area_check: 0,
      business_check: 0,

      bus_contacts: 0,
      citizen_contacts: 0,
      substances_seized: 0,
      firearms_seized: 0,

      vehicle_posted: 0,
      vehicle_towed: 0,
      notes: "",
    },
    update_ready: false,
    valid: true,
    name: "",
    locRules: [(v) => !!v || "Location is required"],
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],

    types: ["Traffic", "Warrant", "Dispatch", "Complaint"],
    area_items: ["Downtown Corridor", "DEEDS", "City of Reno", "Other"],
    mission_types: [
      "DID Operation (ex: 4th street saturation Op/ Shopping Cart Op/ UC op)",
      "Area Check",
      "Ambassador Assist",
      "Business Check",
      "Call for Service",
      "Camp Cleanup",
      "City Walk",
      "Service Request",
      "Warrant Sweep",
      "Motel Inspection",
      "CPTED",
      "Other",
    ],
    checkbox: false,
  }),
  watch: {
    addedit_update_now: function (val) {
      if (this.update_ready) {
        this.update_ready = true;
        this.swall_it("Entry Status", "Entry Saved", "success");
        this.stat_data = this.mno(this.stat_data_new);
        this.$nextTick(() => {
          this.stat_data.stat_date = this.format_date_us(new Date());
        });

        console.log("Stat Date: " + this.stat_data.stat_date);
      }
    },
    incoming_edit: function (stat) {
      this.mrbreakpoint("incoming_edit27");
      this.stat_data = this.mno(stat);
      this.stat_data.stat_date = this.format_date_us(this.stat_data.stat_date);
      this.stat_data.area = this.stat_data.area.trim();
      console.log("before: " + this.stat_data.deeds_hours);
      // this.stat_data.deeds_hours = parseFloat(
      //   this.stat_data.deeds_hour
      // ).toFixed(2);
      this.stat_data.deeds_hours = this.stat_data.deeds_hours
        .toFixed(2)
        .toString();

      console.log("after: " + this.stat_data.deeds_hours);
      console.log("area: " + this.stat_data.area);

      if (this.stat_data.area.indexOf("Other") > -1) {
        this.stat_data.area = "Other";
      }
    },
  },
  computed: {
    team_met() {
      if (this.edit_on) {
        if (this.stat_data.team == "MET1" || this.stat_data.team == "MET2") {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.team == "MET1" || this.team == "MET2") {
          return true;
        } else {
          return false;
        }
      }
    },
    dhours15() {
      let dhours15 = [];
      for (let hour = 0; hour <= 20; hour++) {
        for (let minutes = 0; minutes < 60; minutes += 15) {
          // let inc = `${hour.toString().padStart(2, "0")}:${minutes
          //   .toString()
          //   .padStart(2, "0")}`;
          let inc = (parseFloat(hour) + parseFloat(minutes / 100)).toFixed(2);
          dhours15.push(inc);
        }
      }
      return dhours15;
    },
    d10() {
      var d10 = [];
      for (let index = 0; index < 11; index++) {
        d10.push(index);
      }
      return d10;
    },
    d20() {
      var d20 = [];
      for (let index = 0; index < 21; index++) {
        d20.push(index);
      }
      return d20;
    },
    d30() {
      var d30 = [];
      for (let index = 0; index < 31; index++) {
        d30.push(index);
      }
      return d30;
    },
    d60() {
      var d60 = [];
      for (let index = 0; index < 61; index++) {
        d60.push(index);
      }
      return d60;
    },
    grants() {
      var grants = [];
      grants.push("None");
      for (let index = 0; index < this.lst_grants.length; index++) {
        const element = this.lst_grants[index];
        grants.push(element.grant_name);
      }
      return grants;
    },
    tsep_fromId() {
      return this.$store.state.edit_tsep_fromId;
    },
  },
  methods: {
    team_select() {
      let self = this;
      console.log("team_select save");
      if (this.team != "") {
        //save user team
        let formIn = {};
        formIn.email = this.$store.state.user.email;
        formIn.token = this.$store.state.user.token;
        formIn.team = this.team;
        formIn.apiname = "save_team_user";

        let self = this;
        this.$store
          .dispatch("anyapi", formIn)
          .then((data) => {
            self.team = data;
            self.panels = 0;
          })
          .catch((msg) => {
            self.dialog = false;
            this.show_loader(false);
            this.swall_it("Error save_team_user", msg, "error", null, null);
          });
      }
    },
    quit_view() {
      //this will also set read only to false putting us in the basic state
      this.$emit("cancel_edit27", this.stat_data);
    },
    save_stat() {
      var total = 0;
      let stat_data = this.mno(this.stat_data);
      //   this.mrbreakpoint("save_stat 1");
      if (this.stat_data.area == "" || this.stat_data.area == undefined) {
        this.swall_it(
          "Save Status ",
          "Please be sure you have selected an Area and a Mission before submitting. ",
          "warning",
          null,
          null
        );
        return true;
      }
      if (
        this.team == "" ||
        this.team == null ||
        this.stat_data.area == undefined
      ) {
        this.swall_it(
          "Save Status ",
          "Team not found. Change you team and try again. ",
          "warning",
          null,
          null
        );
        return true;
      }

      stat_data.team = this.team;
      stat_data.deeds_hours = parseFloat(stat_data.deeds_hours);

      stat_data.stat_date = this.format_date_sql(new Date(stat_data.stat_date));
      console.log(stat_data.stat_date);
      console.log("notes:" + stat_data.notes);

      stat_data.patrol_investigations = parseInt(
        stat_data.patrol_investigations
      );
      stat_data.subject_stops = parseInt(stat_data.subject_stops);
      stat_data.gtar = parseInt(stat_data.gtar);

      stat_data.planned_operations = parseInt(stat_data.planned_operations);
      stat_data.cfs_handled = parseInt(stat_data.cfs_handled);
      stat_data.cfs_handled_reports = parseInt(stat_data.cfs_handled_reports);
      stat_data.felony_arrests = parseInt(stat_data.felony_arrests);

      stat_data.gross_mido_arrests = parseInt(stat_data.gross_mido_arrests);
      stat_data.misdo_arrests = parseInt(stat_data.misdo_arrests);
      stat_data.rmc_cites = parseInt(stat_data.rmc_cites);
      stat_data.traffic_stops = parseInt(stat_data.traffic_stops);

      stat_data.traffic_citations = parseInt(stat_data.traffic_citations);
      stat_data.warnings = parseInt(stat_data.warnings);
      stat_data.area_check = parseInt(stat_data.area_check);
      stat_data.business_check = parseInt(stat_data.business_check);

      stat_data.bus_contacts = parseInt(stat_data.bus_contacts);
      stat_data.citizen_contacts = parseInt(stat_data.citizen_contacts);
      stat_data.substances_seized = parseInt(stat_data.substances_seized);
      stat_data.firearms_seized = parseInt(stat_data.firearms_seized);

      stat_data.vehicle_posted = parseInt(stat_data.vehicle_posted);
      stat_data.vehicle_towed = parseInt(stat_data.vehicle_towed);

      this.update_ready = true;
      this.$emit("save_stat27", stat_data);
    },
    cancel_edit() {
      this.$emit("cancel_edit27", this.stat_data);
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.init();
      this.show_loader(false);
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    init() {
      let self = this;
      console.log(this.show_addedit);
      setTimeout(() => {
        self.stat_data = self.mno(self.stat_data_new);
        this.stat_data.team = this.team;
        this.stat_data.stat_date = this.format_date_us(new Date());
      }, 500);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
